const YES_TEXT_CLASS = "text-yes";
const NO_TEXT_CLASS = "text-no";
const YES_BADGE_CLASS = "text-yes bg-yes-subtle border border-transparent";
const NO_BADGE_CLASS = "text-no bg-no-subtle border border-transparent";
const DEFAULT_BADGE_CLASS = "text-t3 bg-surface-subtle";

export interface BetTypeDisplayResult {
    label: string;
    textClass?: string;
    badgeClass?: string;
    isNeutral: boolean;
}

export function getBetTypeDisplay( betType?: number | null, matchups?: any[] ): BetTypeDisplayResult {
    if ( betType === 1 ) {
        const label = matchups && matchups.length > 0 ? ( matchups[0]?.abbr || "Yes" ) : "Yes";
        return {
            label,
            textClass: YES_TEXT_CLASS,
            badgeClass: YES_BADGE_CLASS,
            isNeutral: false,
        };
    }

    if ( betType === 2 ) {
        const label = matchups && matchups.length > 1 ? ( matchups[1]?.abbr || "No" ) : "No";
        return {
            label,
            textClass: NO_TEXT_CLASS,
            badgeClass: NO_BADGE_CLASS,
            isNeutral: false,
        };
    }

    return {
        label: "No Position",
        badgeClass: DEFAULT_BADGE_CLASS,
        isNeutral: true,
    };
}

export function getBetTypeTextClass( betType?: number | null ) {
    return getBetTypeDisplay( betType ).textClass ?? "";
}

export function getBetTypeBadgeClass( betType?: number | null ) {
    return getBetTypeDisplay( betType ).badgeClass ?? "";
}
